module.exports = __webpack_public_path__ + "static/media/location-icon.97dca5f5.svg";